<h1></h1>
<h2>Request(s) for Supporting Documents</h2>
<button type="button" hidden>Focus Button</button>
<div   class="table-one-wrapper scroll-table sd-table">
    <div class="table-wrapper">
        <div class="table-responsive">
            <table mat-table  [dataSource]="dataSource" matSort (matSortChange)="onClickToSortHeader($event)" class="mat-elevation-z8 base-table">

                <ng-container matColumnDef="dateSent">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header >
                        {{data?.labelCaption['Supporting_Documents_Date_Sent']}}
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.dateSent}}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header >
                        {{data?.labelCaption['Supporting_Documents_Action']}}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <a class="pointer"  (click)="onClicktoOpenDetailDialog(element)">{{element.actionName}}</a>
                        </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header >
                        {{data?.labelCaption['Supporting_Documents_Status']}}
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.statusName}}</td>
                </ng-container>
                <ng-container matColumnDef="statusUpdatedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header >
                        {{data?.labelCaption['Supporting_Documents_Status_Updated_Date']}}
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.statusUpdatedDate}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
            </table>
        </div>
        <ng-container *ngIf="totalCount == 0">
            <div class="empty-table-content">
                <p>No records available.</p>
            </div>
        </ng-container>
        <div class="row" *ngIf="totalCount > 10">
            <div class="col-md-12">
                <app-paginator [items-per-page]="numberOfItemsPerPage" [total-length]="totalCount"
                    (emitData)='onClickToChangePageSize($event)'>
                </app-paginator>
            </div>
        </div>
        <div mat-dialog-actions class="my-3">
            <div class="row w-100 no-gutters">
              <div class="col-6">
                <button type="button" class="secondary-button"  (click)='closeDialog()'>{{data?.labelCaption['Supporting_Documents_Cancel']}}</button>
              </div>
            </div>
          </div>
    </div>
</div>